import React from 'react';
import { Box, Typography } from '@mui/material';

import { WorkingTimeSidebarInfoIcon } from '../../../../../Icons';

interface SectionHeaderProps {
  label: string;
}

export const SectionHeader = ({
  label,
}: SectionHeaderProps) => {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: '#9D9D9D',
      fontSize: '12px',
    }}>
      <Typography sx={{
        fontSize: '10px',
        fontWeight: '400',
      }}>
        {label}
      </Typography>
      {/*<WorkingTimeSidebarInfoIcon fontSize="inherit"/>*/}
    </Box>
  );
}
